(function () {
  var STORAGE_KEY = 'hn_selected_city';
  function getCity() { return localStorage.getItem(STORAGE_KEY); }
  function setCity(city) { localStorage.setItem(STORAGE_KEY, city); }
  function showPopup() { var o = document.getElementById('city-popup-overlay'); if (o) o.style.display = 'flex'; }
  function hidePopup() { var o = document.getElementById('city-popup-overlay'); if (o) o.style.display = 'none'; }
  function updateBar(city) { var b = document.getElementById('city-change-bar'); if (b) b.textContent = '📍 ' + city + ' — Change City'; }

  function hideKarachiProducts(city) {
    if (!city || city === 'Karachi') return;
    document.querySelectorAll('[data-karachi-only="true"]').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  function filterProducts(city) {
    if (!city || city === 'Karachi') {
      var content = document.getElementById('city-product-content');
      var block = document.getElementById('city-unavailable-block');
      if (content) content.style.display = '';
      if (block) block.style.display = 'none';
      return;
    }

    hideKarachiProducts(city);

    var flag = document.getElementById('city-karachi-only-product');
    if (flag) {
      var content = document.getElementById('city-product-content');
      var block = document.getElementById('city-unavailable-block');
      if (content) content.style.display = 'none';
      if (block) block.style.display = 'block';
    }
  }

  function observeRecommendations(city) {
    if (!city || city === 'Karachi') return;
    var target = document.querySelector('product-recommendations');
    if (!target) return;
    var observer = new MutationObserver(function() {
      hideKarachiProducts(city);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    var city = getCity();

    document.querySelectorAll('.city-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var c = this.getAttribute('data-city');
        setCity(c);
        hidePopup();
        window.location.reload();
      });
    });

    var bar = document.getElementById('city-change-bar');
    if (bar) bar.addEventListener('click', showPopup);

    if (!city) {
      showPopup();
    } else {
      updateBar(city);
      filterProducts(city);
      observeRecommendations(city);
    }
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
